export interface IFieldChangeData {
  value: string;
  fieldName: string;
  payload?: object;
}

export interface IFieldData {
  fieldName?: string;
  value: string;
  error: string;
}

export interface IWebhook {
  key: string;
  url: string;
  environment: Environments;
}

export interface IMember {
  memberFirstName: IFieldData;
  memberLastName: IFieldData;
  memberRole?: IFieldData;
  email: IFieldData;
}

export interface IMembersData {
  name: string;
  email: string;
  role: string;
}

export enum MembersPopupType {
  addMember = 'addMember',
  addMemberSuccess = 'addMemberSuccess',
  addMemberFail = 'addMemberFail',
}

export enum DeleteAllDataPopupType {
  deleteAllData = 'deleteAllData',
  deleteAllDataSuccess = 'deleteAllDataSuccess',
  deleteAllDataFail = 'deleteAllDataFail',
}

export enum TestWebhooksPopupType {
  testWebhookSuccess = 'testWebhookSuccess',
  testWebhookFail = 'testWebhookFail',
  configureWebhookSuccess = 'configureWebhookSuccess',
  configureWebhookFail = 'configureWebhookFail',
}

export interface IPopupData {
  title: string;
  description: string;
  status: MembersPopupType | DeleteAllDataPopupType | string;
}

export interface Ikeys {
  sunbitKey: string;
  secretKey: string;
  environment: Environments;
}

export enum EnvironmentStatus {
  INITIAL = 'INITIAL',
  ENABLED = 'ENABLED',
  REQUEST_PENDING = 'REQUEST_PENDING',
}

export enum Environments {
  prod = 'PRODUCTION',
  sandbox = 'SANDBOX',
}

export enum signInPopupType {
  signInFail = 'signInFail',
  signInLocked = 'signInLocked',
  resetPasswordFailedLocked = 'resetPasswordFailedLocked',
  resetPasswordFailedGeneral = 'resetPasswordFailedGeneral',
  resetPasswordSuccess = 'resetPasswordSuccess',
}
